export const APP_STORE_REVIEW_COOKIE_NAME = 'x-launch-type';
export const APP_STORE_REVIEW_COOKIE_VALUE = 'native';

export const APP_STORE_REVIEW_HEADER_NAME = APP_STORE_REVIEW_COOKIE_NAME;
export const APP_STORE_REVIEW_HEADER_VALUE = APP_STORE_REVIEW_COOKIE_VALUE;

export const NATIVE_COMMON_PROVIDER_ID = 'booongo';
export const NATIVE_CASINO_PROVIDER_ID = 'fired-up-games';
export const NATIVE_CASINO_PROVIDER_ID_BY = 'fired-up-games-by';

export const NATIVE_CASINO_PROVIDERS = [
  NATIVE_CASINO_PROVIDER_ID,
  NATIVE_CASINO_PROVIDER_ID_BY,
];
